/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Cost_LabelInputs */

const en_endpoint_cost_label = /** @type {(inputs: Endpoint_Cost_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cost estimate`)
};

const zh_hans1_endpoint_cost_label = /** @type {(inputs: Endpoint_Cost_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`费用估算`)
};

const pt_br2_endpoint_cost_label = /** @type {(inputs: Endpoint_Cost_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimativa de custo`)
};

const es_endpoint_cost_label = /** @type {(inputs: Endpoint_Cost_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimación de costo`)
};

const fr_endpoint_cost_label = /** @type {(inputs: Endpoint_Cost_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimation du coût`)
};

const de_endpoint_cost_label = /** @type {(inputs: Endpoint_Cost_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenschätzung`)
};

const ru_endpoint_cost_label = /** @type {(inputs: Endpoint_Cost_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оценка стоимости`)
};

const it_endpoint_cost_label = /** @type {(inputs: Endpoint_Cost_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima del costo`)
};

/**
* | output |
* | --- |
* | "Cost estimate" |
*
* @param {Endpoint_Cost_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_label = /** @type {((inputs?: Endpoint_Cost_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_label(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_label(inputs)
	if (locale === "es") return es_endpoint_cost_label(inputs)
	if (locale === "fr") return fr_endpoint_cost_label(inputs)
	if (locale === "de") return de_endpoint_cost_label(inputs)
	if (locale === "ru") return ru_endpoint_cost_label(inputs)
	if (locale === "it") return it_endpoint_cost_label(inputs)
	return en_endpoint_cost_label(inputs)
});